@if (ssvc.loading()) {
  <p-progress-bar mode="indeterminate" [style]="{ height: '4px' }"></p-progress-bar>
} @else {
  <ng-schedule-main-settings></ng-schedule-main-settings>
  <ng-schedule-due-time></ng-schedule-due-time>
  <ng-schedule-overdue></ng-schedule-overdue>
}
